export default __webpack_public_path__ + "static/media/paper.ed2df7a3.svg";